import { IconWrapper } from '../runtime';
export default IconWrapper('single-people', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.25 3.74982C5.25 2.23103 6.48122 0.999817 8 0.999817C9.51878 0.999817 10.75 2.23103 10.75 3.74982C10.75 5.2686 9.51878 6.49982 8 6.49982C6.48122 6.49982 5.25 5.2686 5.25 3.74982Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.5 12.9998C2.5 10.7907 4.29086 8.99982 6.5 8.99982H9.5C11.7091 8.99982 13.5 10.7907 13.5 12.9998V14.1998C13.5 14.3655 13.3657 14.4998 13.2 14.4998H2.8C2.63431 14.4998 2.5 14.3655 2.5 14.1998V12.9998Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});